var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49506 4.12319C1.57458 7.33638 3.13449 12.3086 7.42326 16.6172C11.6208 20.834 16.8171 22.4106 19.8922 19.5495C21.5745 17.9841 21.3259 15.2121 19.2476 13.3596L19.0578 13.1983C17.1296 11.637 14.331 11.632 12.6216 13.1712L12.534 13.2534L12.4843 13.2116C12.2975 13.0524 12.0544 12.8307 11.7609 12.5389L11.4638 12.2369L11.1575 11.9107C11.0656 11.8101 10.9839 11.7178 10.9119 11.634L10.7883 11.4877L10.7188 11.5629C12.406 9.86789 12.422 6.84909 10.7246 4.82112C8.83975 2.56903 5.9807 2.48865 4.49506 4.12319ZM9.34619 5.97499C10.5252 7.38369 10.3934 9.34164 9.44486 10.2946L9.29694 10.4341C8.6676 11.0002 8.05323 11.334 10.3282 13.6475C12.7828 16.1437 13.0889 15.268 13.7283 14.5986C14.7327 13.5896 16.6995 13.4965 18.0515 14.7016C19.5467 16.0344 19.3847 17.5661 18.6677 18.2333C16.449 20.2977 12.2001 18.8678 8.69723 15.3489C5.1944 11.8299 3.63985 7.73682 5.82526 5.33238C6.33259 4.77419 7.92364 4.27531 9.34619 5.97499Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneOutline);
export default __webpack_public_path__ + "static/media/phone_outline.35f1d125efc20e351bf8bbea172c1247.svg";
export { ForwardRef as ReactComponent };